import Transactions from '../components/transaction/TransactionTable';

const TransactionsPage = () => {
  return (
    <>
      <Transactions />
    </>
  );
};

export default TransactionsPage;
